<script setup lang="ts">
import { BusPurchaseQtyOption } from '~/apiClient';

const { tt } = useTypedI18n();

type Option = { label: string; value: BusPurchaseQtyOption };

const options: Option[] = [
    { label: tt('signup.fields.stats.unknown'), value: BusPurchaseQtyOption.unknown },
    { label: BusPurchaseQtyOption.NUMBER_0, value: BusPurchaseQtyOption.NUMBER_0 },
    { label: BusPurchaseQtyOption['1-2'], value: BusPurchaseQtyOption['1-2'] },
    { label: BusPurchaseQtyOption['2-5'], value: BusPurchaseQtyOption['2-5'] },
    { label: BusPurchaseQtyOption['5-10'], value: BusPurchaseQtyOption['5-10'] },
    { label: BusPurchaseQtyOption['10-20'], value: BusPurchaseQtyOption['10-20'] },
    { label: BusPurchaseQtyOption['>20'], value: BusPurchaseQtyOption['>20'] },
];

const model = defineModel<BusPurchaseQtyOption | undefined>();
</script>

<template>
    <USelectMenu v-model="model" :items="options" value-key="value" :search-input="false" />
</template>
